module.exports = __webpack_public_path__ + "static/img/包裝第四組組長-陳進茂.f71cc4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/包裝第四組組長-陳進茂.jpg
// module id = XO96
// module chunks = 1